import en from "vee-validate/dist/locale/en"

export default {
  messages: en.messages,
  names: {
    email: "E-mail address",
    name: "Name and last name",
  },
  fields: {
    email: {
      required: "{_field_} is required.",
    },
    name: {
      required: "{_field_} are required.",
    },
  }
}
